module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tw-flex tw-pointer-events-auto",
    class: _vm.isHeader ? 'tw-max-h-[500px]' : 'hover:tw-bg-gray-500/[.25] tw-rounded-bl-lg tw-transition-all tw-duration-200 tw-max-h-full',
    on: {
      "mouseenter": function($event) {
        _vm.mouseOver()
      },
      "mouseleave": function($event) {
        _vm.mouseLeave()
      }
    }
  }, [_c('div', {
    ref: "scrollableHeader",
    staticClass: "tw-grid tw-gap-2 tw-py-2 tw-px-2 tw-grid-flow-row tw-auto-rows-max tw-overflow-hidden tw-w-full"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    ref: "verticaltrackHeader",
    staticClass: "tw-bg-gray-300 tw-w-2",
    class: {
      'tw-hidden': !_vm.showScrollbar
    }
  }, [_c('div', {
    ref: "verticalthumbHeader",
    staticClass: "tw-relative tw-transition-all tw-duration-200",
    class: _vm.activeEffect ? 'tw-bg-gray-400' : 'tw-bg-gray-500'
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7de16834"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/notification/notification-scroll/notification-scroll.vue.html
// module id = U0mv
// module chunks = 2